// The printed page is 30 cm wide at 150 dpi. A photo needs at least
// (its share of the page width) x (printed page width in px) pixels to
// print sharply.
//
// slotWidth and pageWidth must be in the SAME CSS unit (both from layout).
// That keeps the result identical on iOS (points) and Android (physical
// pixels, because index.html scales the viewport by 1/devicePixelRatio).
// Do not bring window.outerWidth, devicePixelRatio or the platform into
// this: the old formula did, and iOS ended up rounding to a 400 px grid.
const PAGE_WIDTH_INCHES = 30 / 2.54;
const PRINT_DPI = 150;

export function recommendedPixels({
  slotWidth,
  pageWidth,
  ratioWidth,
  ratioHeight,
}) {
  if (!slotWidth || !pageWidth) return { width: 0, height: 0 };
  const width = Math.round(
    PAGE_WIDTH_INCHES * (slotWidth / pageWidth) * PRINT_DPI,
  );
  const height = Math.round(width * (ratioHeight / ratioWidth));
  return { width, height };
}
